import React, { useEffect } from 'react';
import { FaGithub } from 'react-icons/fa';

// Per the mflow knowledge base "Autonomous coding agent" doc: GitHub's callback does the whole
// OAuth exchange server-side and redirects here with EITHER `?error=<code>` (failure) or no query
// params at all (success) — unlike Slack, there's no `?status=connected` marker to check for.
const OAUTH_ERROR_MESSAGES: Record<string, string> = {
  missing_state: 'Connection failed: the request was missing a required parameter. Please try again.',
  user_not_found: 'Connection failed: your account could not be verified. Please log out and try again.',
  exchange_failed: 'Connection failed: GitHub did not confirm the connection. Please try again.',
};

const ConnectGithubPage: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const errorCode = params.get('error');
  const errorMessage = errorCode ? (OAUTH_ERROR_MESSAGES[errorCode] ?? 'Connection failed. Please try again.') : null;

  useEffect(() => {
    if (errorCode) return;
    if (window.opener) window.opener.postMessage({ type: 'github-connected' }, '*');
    window.close();
  }, [errorCode]);

  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center p-4">
      <div className="card bg-base-100 shadow-xl w-full max-w-sm">
        <div className="card-body gap-4 items-center text-center">
          <FaGithub className="text-4xl opacity-80" />

          {!errorMessage && !window.opener && (
            <>
              <h2 className="card-title font-display">GitHub Connected</h2>
              <p className="text-sm opacity-70">You can close this window.</p>
              <button className="btn btn-primary btn-sm" onClick={() => window.close()}>
                Close
              </button>
            </>
          )}

          {!errorMessage && window.opener && (
            <>
              <h2 className="card-title font-display">Connecting…</h2>
              <span className="loading loading-spinner loading-md" />
            </>
          )}

          {errorMessage && (
            <>
              <h2 className="card-title font-display text-error">GitHub Connection Error</h2>
              <div className="alert alert-error">
                <span className="text-sm">{errorMessage}</span>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={() => window.close()}>
                Close
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectGithubPage;
